/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "kahapon",
      "-2": "Araw bago ang kahapon",
      "0": "ngayong araw",
      "1": "bukas",
      "2": "Samakalawa",
      "future": {
        "one": "sa {0} araw",
        "other": "sa {0} araw"
      },
      "past": {
        "one": "{0} araw ang nakalipas",
        "other": "{0} araw ang nakalipas"
      }
    },
    "day-narrow": {
      "-1": "kahapon",
      "-2": "Araw bago ang kahapon",
      "0": "ngayong araw",
      "1": "bukas",
      "2": "Samakalawa",
      "future": {
        "one": "sa {0} araw",
        "other": "sa {0} araw"
      },
      "past": {
        "one": "{0} araw ang nakalipas",
        "other": "{0} araw ang nakalipas"
      }
    },
    "day-short": {
      "-1": "kahapon",
      "-2": "Araw bago ang kahapon",
      "0": "ngayong araw",
      "1": "bukas",
      "2": "Samakalawa",
      "future": {
        "one": "sa {0} (na) araw",
        "other": "sa {0} araw"
      },
      "past": {
        "one": "{0} araw ang nakalipas",
        "other": "{0} (na) araw ang nakalipas"
      }
    },
    "hour": {
      "0": "ngayong oras",
      "future": {
        "one": "sa {0} oras",
        "other": "sa {0} oras"
      },
      "past": {
        "one": "{0} oras ang nakalipas",
        "other": "{0} oras ang nakalipas"
      }
    },
    "hour-narrow": {
      "0": "ngayong oras",
      "future": {
        "one": "sa {0} oras",
        "other": "sa {0} oras"
      },
      "past": {
        "one": "{0} oras ang nakalipas",
        "other": "{0} oras ang nakalipas"
      }
    },
    "hour-short": {
      "0": "ngayong oras",
      "future": {
        "one": "sa {0} oras",
        "other": "sa {0} (na) oras"
      },
      "past": {
        "one": "{0} oras ang nakalipas",
        "other": "{0} oras ang nakalipas"
      }
    },
    "minute": {
      "0": "sa minutong ito",
      "future": {
        "one": "sa {0} minuto",
        "other": "sa {0} minuto"
      },
      "past": {
        "one": "{0} minuto ang nakalipas",
        "other": "{0} minuto ang nakalipas"
      }
    },
    "minute-narrow": {
      "0": "sa minutong ito",
      "future": {
        "one": "sa {0} min.",
        "other": "sa {0} min."
      },
      "past": {
        "one": "{0} min. ang nakalipas",
        "other": "{0} min. ang nakalipas"
      }
    },
    "minute-short": {
      "0": "sa minutong ito",
      "future": {
        "one": "sa {0} min.",
        "other": "sa {0} min."
      },
      "past": {
        "one": "{0} min. ang nakalipas",
        "other": "{0} min. ang nakalipas"
      }
    },
    "month": {
      "-1": "nakaraang buwan",
      "0": "ngayong buwan",
      "1": "susunod na buwan",
      "future": {
        "one": "sa {0} buwan",
        "other": "sa {0} buwan"
      },
      "past": {
        "one": "{0} buwan ang nakalipas",
        "other": "{0} buwan ang nakalipas"
      }
    },
    "month-narrow": {
      "-1": "nakaraang buwan",
      "0": "ngayong buwan",
      "1": "susunod na buwan",
      "future": {
        "one": "sa {0} buwan",
        "other": "sa {0} buwan"
      },
      "past": {
        "one": "{0} buwan ang nakalipas",
        "other": "{0} buwan ang nakalipas"
      }
    },
    "month-short": {
      "-1": "nakaraang buwan",
      "0": "ngayong buwan",
      "1": "susunod na buwan",
      "future": {
        "one": "sa {0} buwan",
        "other": "sa {0} buwan"
      },
      "past": {
        "one": "{0} buwan ang nakalipas",
        "other": "{0} buwan ang nakalipas"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "nakaraang quarter",
      "0": "ngayong quarter",
      "1": "susunod na quarter",
      "future": {
        "one": "sa {0} quarter",
        "other": "sa {0} quarter"
      },
      "past": {
        "one": "{0} quarter ang nakalipas",
        "other": "{0} quarter ang nakalipas"
      }
    },
    "quarter-narrow": {
      "-1": "nakaraang quarter",
      "0": "ngayong quarter",
      "1": "susunod na quarter",
      "future": {
        "one": "sa {0} quarter",
        "other": "sa {0} quarter"
      },
      "past": {
        "one": "{0} quarter ang nakalipas",
        "other": "{0} quarter ang nakalipas"
      }
    },
    "quarter-short": {
      "-1": "nakaraang quarter",
      "0": "ngayong quarter",
      "1": "susunod na quarter",
      "future": {
        "one": "sa {0} quarter",
        "other": "sa {0} quarter"
      },
      "past": {
        "one": "{0} quarter ang nakalipas",
        "other": "{0} quarter ang nakalipas"
      }
    },
    "second": {
      "0": "ngayon",
      "future": {
        "one": "sa {0} segundo",
        "other": "sa {0} segundo"
      },
      "past": {
        "one": "{0} segundo ang nakalipas",
        "other": "{0} segundo ang nakalipas"
      }
    },
    "second-narrow": {
      "0": "ngayon",
      "future": {
        "one": "sa {0} seg.",
        "other": "sa {0} seg."
      },
      "past": {
        "one": "{0} seg. ang nakalipas",
        "other": "{0} seg. ang nakalipas"
      }
    },
    "second-short": {
      "0": "ngayon",
      "future": {
        "one": "sa {0} seg.",
        "other": "sa {0} seg."
      },
      "past": {
        "one": "{0} seg. ang nakalipas",
        "other": "{0} seg. ang nakalipas"
      }
    },
    "week": {
      "-1": "nakalipas na linggo",
      "0": "sa linggong ito",
      "1": "susunod na linggo",
      "future": {
        "one": "sa {0} linggo",
        "other": "sa {0} linggo"
      },
      "past": {
        "one": "{0} linggo ang nakalipas",
        "other": "{0} linggo ang nakalipas"
      }
    },
    "week-narrow": {
      "-1": "nakaraang linggo",
      "0": "ngayong linggo",
      "1": "susunod na linggo",
      "future": {
        "one": "sa {0} linggo",
        "other": "sa {0} linggo"
      },
      "past": {
        "one": "{0} linggo ang nakalipas",
        "other": "{0} linggo ang nakalipas"
      }
    },
    "week-short": {
      "-1": "nakaraang linggo",
      "0": "ngayong linggo",
      "1": "susunod na linggo",
      "future": {
        "one": "sa {0} linggo",
        "other": "sa {0} linggo"
      },
      "past": {
        "one": "{0} linggo ang nakalipas",
        "other": "{0} (na) linggo ang nakalipas"
      }
    },
    "year": {
      "-1": "nakaraang taon",
      "0": "ngayong taon",
      "1": "susunod na taon",
      "future": {
        "one": "sa {0} taon",
        "other": "sa {0} taon"
      },
      "past": {
        "one": "{0} taon ang nakalipas",
        "other": "{0} taon ang nakalipas"
      }
    },
    "year-narrow": {
      "-1": "nakaraang taon",
      "0": "ngayong taon",
      "1": "susunod na taon",
      "future": {
        "one": "sa {0} taon",
        "other": "sa {0} taon"
      },
      "past": {
        "one": "{0} taon ang nakalipas",
        "other": "{0} taon ang nakalipas"
      }
    },
    "year-short": {
      "-1": "nakaraang taon",
      "0": "ngayong taon",
      "1": "susunod na taon",
      "future": {
        "one": "sa {0} taon",
        "other": "sa {0} taon"
      },
      "past": {
        "one": "{0} taon ang nakalipas",
        "other": "{0} taon ang nakalipas"
      }
    }
  },
  "locale": "fil"
})
}
